import { Capacitor } from '@capacitor/core';

const DEBUG_STORAGE_KEY = 'analytics-debug';

export const isAnalyticsDebugEnabled = (): boolean => {
  if (import.meta.env.VITE_ANALYTICS_DEBUG === 'true') return true;
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(DEBUG_STORAGE_KEY) === 'true';
};

export const setAnalyticsDebugEnabled = (enabled: boolean): void => {
  if (typeof window === 'undefined') return;
  if (enabled) {
    window.localStorage.setItem(DEBUG_STORAGE_KEY, 'true');
  } else {
    window.localStorage.removeItem(DEBUG_STORAGE_KEY);
  }
};

export const getAnalyticsConsent = (): boolean | null => {
  if (typeof window === 'undefined') return null;
  const stored = window.localStorage.getItem('analytics-consent');
  if (stored === null) return null;
  return stored === 'true';
};

export const shouldTrackAnalytics = (): boolean => {
  if (Capacitor.isNativePlatform()) return true;
  return getAnalyticsConsent() === true;
};

export const getAnalyticsDeviceContext = (): { device: 'mobile' | 'desktop'; platform: 'app' | 'web' } => {
  const platform = Capacitor.isNativePlatform() ? 'app' : 'web';
  if (typeof window === 'undefined') {
    return { device: 'desktop', platform };
  }
  const device = window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  return { device, platform };
};
